import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const outcomes = ['más segura profesionalmente', 'menos desbordada', 'más organizada', 'más clara al intervenir', 'más preparada para acompañar', 'con herramientas concretas', 'con más tranquilidad clínica', 'con más estructura profesional'];
export function TransformationSection() {
  return <section className="py-24 bg-slate-50 relative overflow-hidden" data-id="element-253">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-teal-100/40 blur-[120px] rounded-full pointer-events-none" data-id="element-254" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-255">
        <div className="text-center mb-12" data-id="element-256">
          <span className="text-teal-600 font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-257">
            La Transformación
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-navy-900 uppercase tracking-tight" data-id="element-258">
            Imaginá sentirte…
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-slate-100 mb-16" data-id="element-259">
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-260">
            {outcomes.map((outcome, i) => <div key={i} className="flex items-center gap-4" data-id="element-261">
                <div className="w-8 h-8 rounded-full bg-teal-50 flex items-center justify-center shrink-0" data-id="element-262">
                  <CheckCircle2 className="w-5 h-5 text-teal-500" data-id="element-263" />
                </div>
                <span className="text-lg font-medium text-slate-700" data-id="element-264">
                  {outcome}
                </span>
              </div>)}
          </div>
        </motion.div>

        <div className="text-center" data-id="element-265">
          <p className="font-serif italic text-2xl md:text-3xl text-violet-700 max-w-3xl mx-auto leading-relaxed" data-id="element-266">
            "No se trata de saberlo todo. Se trata de sentirte más acompañada y
            preparada en la práctica real."
          </p>
        </div>
      </div>
    </section>;
}